export const contactPage = {
  uz: {
    contactPageTitle: "Kontaktlar",
  },
  ru: {
    contactPageTitle: "Контакты",
  },
  tj: {
    contactPageTitle: "Тамос",
  },
};
